module.exports = __webpack_public_path__ + "static/media/road-assistance.ac072edb.svg";